import type {IYonerge} from "./yonerge";


export interface IYonergeDTO {
  b: string;
  m: string;
}

export function mapYonergeFromDTO(dto: IYonergeDTO): IYonerge {
  return {
    baslik: dto.b,
    metin: dto.m
  };
}
